import config from 'config';
import supabase from 'services/supabase.client';
import process from 'utils/processResponse';

export const getSession = () => supabase.auth.session();

export const getAuth = () => supabase.auth.user();

export const getAuthId = () => supabase.auth.user().id;

export const getAccessToken = () => getSession()?.access_token;

export const updateUser = async (data) => {
  const response = await supabase.auth.update(data);

  return process(response);
};

export const signUp = async ({ email, password, data }) => {
  const response = await supabase.auth.signUp(
    {
      email: email.toLowerCase(),
      password,
    },
    {
      ...(data && { data }),
    },
  );

  return process(response);
};

export const signInByPassword = async ({ email, password }) => {
  const response = await supabase.auth.signIn({
    email: email.toLowerCase(),
    password,
  });

  return process(response);
};

export const signInWithRefreshToken = async ({ refreshToken }) => {
  const response = await supabase.auth.signIn({ refreshToken });

  return process(response);
};

export const signInWithGoogle = async (email) => {
  const response = await supabase.auth.signIn(
    { 
      provider: 'google',
    },
    {
      redirectTo: config.webUrl,
      shouldCreateUser: false,
      ...(email && { queryParams: { login_hint: email } }),
    },
  );

  return process(response);
};

export const signOut = async () => {
  const response = await supabase.auth.signOut();

  return process(response);
};

export const updatePassword = async (password) => {
  const response = await supabase.auth.update({ password });

  return process(response);
};

export const onAuthStateChange = (callback) => {
  const { data: listener } = supabase.auth.onAuthStateChange(callback);
  return listener;
};
